import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/shops/", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/shops/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/shops", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "shop_code", "shop_name","status"]; //仅筛选少许必要字段
    return Request('get', "api/shops/select", data, false, false, true);
}

async function fetchForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/shops/select", data, false, false, true);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/shops/edit?id=" + id, data);
    } else {
        return Request('post', "api/shops/add" , data);
    }
}


export default {
    fetch,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    save,
    fetchForSelect,
};